<template>
    <section>
        <b-row>
            <b-col :md="12" :lg="4">
                <b-overlay
                    :show="status === 'loading'"
                >
                    <b-card
                    >
                        <div class="d-flex justify-content-between mb-1" style="white-space: nowrap;">
                            <div>
                                <b-button size="sm" @click="handleAllSelect">
                                    <i class="fa fa-check-square" regular></i>
                                    {{ $t('org.common.Select all') }}
                                </b-button>
                                <b-button size="sm" style="margin-left:3px" @click="handleUnselect">
                                    <i class="fa fa-square" regular></i>
                                    {{ $t('org.common.Unselect') }}
                                </b-button>
                            </div>
                            <div>
                                <b-button size="sm" style="margin-left:3px" @click="handleSearch">
                                    <i class="fa fa-search"></i>
                                    {{ $t('org.common.Search') }}
                                </b-button>
                            </div>
                        </div>
                        <b-row>
                            <b-col v-for="(item, index) in products" :key="index" :md="12" style="margin-bottom:0px;">
                                <div style="display:flex;position:relative" class="mb-1">
                                    <b-form-checkbox
                                        v-model="productCodes"
                                        :value="item.productCode"
                                    >
                                        {{ item.productCode }}
                                    </b-form-checkbox>
                                    <div style="position:absolute;right:0;">
                                        {{ $_getDollar(item.cost) }}
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-overlay>

            </b-col>
            <b-col :md="12" :lg="8">
                <b-overlay
                    :show="status === 'loading'"
                >
                    <b-card
                        no-body
                    >
                        <div class="b-table-sticky-header table-responsive" style="max-height:900px;">
                            <b-table-simple
                                no-border-collapse
                            >
                                <b-thead>
                                    <b-tr>
                                        <b-th>
                                            {{ $t('v4.AWS Account / Project Name') }}
                                        </b-th>
                                        <b-th>
                                            {{ $t('v4.Product') }}
                                        </b-th>
                                        <b-th>
                                            {{ $t('v4.Cost') }}
                                        </b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody v-if="productDetail.length === 0">
                                    <b-tr>
                                        <b-td colspan="3">
                                            <div class="d-flex justify-content-center align-items-center flex-column text-center">
                                                <SVGEmptyIcon/>
                                                <span>{{ $t('org.dashboard.No data') }}</span>
                                            </div>
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                                <b-tbody>
                                    <template v-for="(item, index) in productDetail">
                                        <template>
                                            <b-tr v-for="(subItem, subIndex) in item.product" :key="`${item.usageAccountId}-${subIndex}`">
                                                <b-td :rowspan="item.product.length + (item.product.length > 1 ? 1 : 0)" v-if="subIndex === 0">
                                                    {{ item.usageAccountId }} <br>
                                                    {{ item.projectName }}
                                                </b-td>
                                                <b-td>
                                                    {{ subItem.productCode }}
                                                </b-td>
                                                <b-td class="text-right">
                                                    {{ $_getDollar(subItem.cost) }}
                                                </b-td>
                                            </b-tr>
                                        </template>
                                        <template>
                                            <b-tr :key="index" v-if="item.product.length > 1">
                                                <b-th>
                                                    {{ $t('v4.Sub Total') }}
                                                </b-th>
                                                <b-th class="text-right">
                                                    {{ $_getDollar(item.subTotal) }}
                                                </b-th>
                                            </b-tr>
                                        </template>
                                    </template>
                                </b-tbody>
                                <b-tfoot>
                                    <b-tr>
                                        <b-th colspan="2" class="text-vuesign-warning">
                                            {{ $t('v4.All Total') }}
                                        </b-th>
                                        <b-th class="text-vuesign-warning text-right">
                                            {{ $_getDollar(allTotalCost) }}
                                        </b-th>
                                    </b-tr>
                                </b-tfoot>
                            </b-table-simple>
                        </div>
                    </b-card>
                </b-overlay>
            </b-col>
        </b-row>
    </section>

</template>

<script>
import { getCurrentInstance, toRefs, ref, computed, watch } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        SVGEmptyIcon
    },
    props: [
        'month',
        'qtypeParam'
    ],
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const status = computed(() => store.getters['$_allConsolidatedProduct/status'])
        const productCodes = ref([])
        const { month, qtypeParam } = toRefs(props)
        const products = computed(() => store.getters['$_allConsolidatedProduct/products'])
        const productDetail = computed(() => store.getters['$_allConsolidatedProduct/productDetail'])

        const allTotalCost = computed(() => {
            return productDetail.value.reduce((accumulator, currentValue) => {
                accumulator += currentValue.subTotal
                return accumulator
            }, 0)
        })
        const handleAllSelect = () => {
            const allProducts = products.value.map(item => item.productCode)
            productCodes.value = allProducts
        }
        const handleUnselect = () => {
            productCodes.value = []
        }
        const fetchAllConsolidatedProducts = (params) => store.dispatch('$_allConsolidatedProduct/fetchAllConsolidatedProducts', params)
        const fetchAllConsolidatedProductDetail = (params) => store.dispatch('$_allConsolidatedProduct/fetchAllConsolidatedProductDetail', params)

        const handleSearch = () => {
            fetchAllConsolidatedProductDetail({
                ...qtypeParam.value,
                month: month.value,
                productCodes: productCodes.value
            })
        }
        const getInitialData = () => {
            fetchAllConsolidatedProducts({
                ...qtypeParam.value,
                month: month.value
            })
        }
        watch(month, (value, oldValue) => {
            productCodes.value = []
            getInitialData()
        })
        return {
            status,
            products,
            productDetail,
            productCodes,
            allTotalCost,
            handleAllSelect,
            handleUnselect,
            handleSearch
        }
    }
}
</script>

<style>

</style>
